// src/contexts/BreakpointsContext.tsx
import { createContext, ReactNode } from 'react';
import { useBreakpointValue } from '@chakra-ui/react';

interface BreakpointsContextType {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  isLargeScreen: boolean;
  isSmallScreen: boolean;
  isXLargeScreen: boolean;
  isXXLargeScreen: boolean;
}

// eslint-disable-next-line react-refresh/only-export-components
export const BreakpointsContext = createContext<BreakpointsContextType | undefined>(undefined);

export const BreakpointsProvider = ({ children }: { children: ReactNode }) => {
  const isMobile = useBreakpointValue({ base: true, sm: true, md: false }) ?? false;
  const isTablet = useBreakpointValue({ base: false, sm: false, md: true, lg: false }) ?? false;
  const isDesktop = useBreakpointValue({ base: false, sm: false, md: false, lg: true }) ?? false;
  const isLargeScreen = useBreakpointValue({ base: false, sm: false, md: false, lg: true, xl: false }) ?? false;
  const isXLargeScreen = useBreakpointValue({ base: false, sm: false, md: false, lg: false, xl: true }) ?? false;
  const isXXLargeScreen =
    useBreakpointValue({ base: false, sm: false, md: false, lg: false, xl: false, '2xl': true }) ?? false;
  const isSmallScreen = useBreakpointValue({ base: true, sm: true, md: true, lg: false }) ?? false;

  const value = {
    isMobile,
    isTablet,
    isDesktop,
    isLargeScreen,
    isSmallScreen,
    isXLargeScreen,
    isXXLargeScreen,
  };

  return <BreakpointsContext.Provider value={value}>{children}</BreakpointsContext.Provider>;
};
